import { SignupBillingCallbackType } from '@energy-retailer/constants';
import { z } from 'zod';

export const billingDataSchema = z.object({
  result: z.nativeEnum(SignupBillingCallbackType),
  sessionId: z.string(),
});

export const billingResultSchema = z
  .string()
  .transform((data) => JSON.parse(data))
  .pipe(billingDataSchema);

export type BillingResultSchema = z.infer<typeof billingResultSchema>;
